const paymentMethodsPT = {
    "view": {
        "table": {
            "title": "Sua lista de métodos de pagamento",
            "column": {
                "cardholder_name": "Nome do Titular",
                "card_number": "Número do Cartão",
                "expiry_month": "Mês de Expiração",
                "expiry_year": "Ano de Expiração",
                "type": "Tipo",
                "status": "Status",
                "action": "Ação"
            },
            "label": {
                "is_default": "Padrão",
                "is_secondary": "Secundário",
                "is_valid": "Válido",
                "is_expired": "Expirado",
                "not_available": "Não Disponível",
                "month_january": "Janeiro",
                "month_february": "Fevereiro",
                "month_march": "Março",
                "month_april": "Abril",
                "month_may": "Maio",
                "month_june": "Junho",
                "month_july": "Julho",
                "month_august": "Agosto",
                "month_september": "Setembro",
                "month_october": "Outubro",
                "month_november": "Novembro",
                "month_december": "Dezembro"
            },
            "dropdown": {
                "action": "Ação",
                "edit": "Editar",
                "delete": "Excluir"
            }
        },
        "message": {
            "maxPaymentMethodsLimitReached": "Você atingiu o limite de 3 métodos de pagamento. Se quiser adicionar um novo pagamento, pode fazê-lo excluindo um existente.",
            "success": "Método de pagamento foi removido!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        },
        "modal": {
            "delete": {
                "header": "Excluir Método de Pagamento {{cardNumber}}",
                "body": "Tem certeza de que deseja excluir este método de pagamento?"
            }
        }
    },
    "add": {
        "title": "Adicionar Método de Pagamento",
        "form": {
            "label": {
                "card_details": "Detalhes do Cartão",
                "cardholder_name": "Nome do Titular",
                "card_number": "Número do Cartão",
                "expiry_month": "Mês de Expiração",
                "expiry_year": "Ano de Expiração (AAAA)",
                "security_code_cvc": "Código de Segurança (CVC)",
                "billing_details": "Detalhes de Cobrança",
                "country": "País",
                "street_and_number": "Rua e Número",
                "city": "Cidade",
                "postal_code": "Código Postal"
            },
            "help_text": {
                "security_code_cvc": "O código de segurança (CVC) do seu cartão é o número de 3 ou 4 dígitos localizado na parte de trás da maioria dos cartões."
            },
            "options": {
                "month": {
                    "january": "Janeiro",
                    "february": "Fevereiro",
                    "march": "Março",
                    "april": "Abril",
                    "may": "Maio",
                    "june": "Junho",
                    "july": "Julho",
                    "august": "Agosto",
                    "september": "Setembro",
                    "october": "Outubro",
                    "november": "Novembro",
                    "december": "Dezembro"
                },
                "expiry_month": {
                    "select": "Selecione o Mês de Expiração"
                },
                "country": {
                    "select": "Selecione o País"
                }
            },
            "button": {
                "submit": "Enviar"
            },
            "validation": {
                "expiry_month_required": "Mês de Expiração é obrigatório",
                "expiry_month_valid": "Mês de Expiração não deve estar no passado",
                "country_required": "País é obrigatório"
            }
        },
        "message": {
            "success": "Método de pagamento foi adicionado!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        },
        "modal": {
            "addPaymentMethod": {
                "header": "Tem certeza de que gostaria de adicionar este método de pagamento ao seu perfil?",
                "body": "Por meio deste, você garante que todos os dados fornecidos são verdadeiros. Você é o único e legalmente responsável pelos dados fornecidos e pela veracidade dessas informações.",
                "button": {
                    "cancel": "Cancelar",
                    "confirm": "Confirmar"
                }
            }
        }
    },
    "update": {
        "title": "Atualizar Método de Pagamento",
        "form": {
            "label": {
                "card_details": "Detalhes do Cartão",
                "cardholder_name": "Nome do Titular",
                "card_number": "Número do Cartão",
                "expiry_month": "Mês de Expiração",
                "expiry_year": "Ano de Expiração (AAAA)",
                "security_code_cvc": "Código de Segurança (CVC)",
                "billing_details": "Detalhes de Cobrança",
                "country": "País",
                "street_and_number": "Rua e Número",
                "city": "Cidade",
                "postal_code": "Código Postal",
                "set_as_default": "Definir como Padrão"
            },
            "help_text": {
                "security_code_cvc": "O código de segurança (CVC) do seu cartão é o número de 3 ou 4 dígitos localizado na parte de trás da maioria dos cartões."
            },
            "options": {
                "month": {
                    "january": "Janeiro",
                    "february": "Fevereiro",
                    "march": "Março",
                    "april": "Abril",
                    "may": "Maio",
                    "june": "Junho",
                    "july": "Julho",
                    "august": "Agosto",
                    "september": "Setembro",
                    "october": "Outubro",
                    "november": "Novembro",
                    "december": "Dezembro"
                },
                "expiry_month": {
                    "select": "Selecione o Mês de Expiração"
                },
                "country": {
                    "select": "Selecione o País"
                }
            },
            "button": {
                "submit": "Enviar"
            },
            "validation": {
                "expiry_month_required": "Mês de Expiração é obrigatório",
                "expiry_month_valid": "Mês de Expiração não deve estar no passado",
                "country_required": "País é obrigatório"
            }
        },
        "message": {
            "success": "Método de pagamento foi atualizado!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        },
        "modal": {
            "updatePaymentMethod": {
                "header": "Tem certeza de que gostaria de atualizar seu método de pagamento?",
                "body": "Por meio deste, você garante que todos os dados fornecidos são verdadeiros. Você é o único e legalmente responsável pelos dados fornecidos e pela veracidade dessas informações.",
                "button": {
                    "cancel": "Cancelar",
                    "confirm": "Confirmar"
                }
            }
        }
    }
};

export default paymentMethodsPT;